<template>
  <footer class="jsk-block pt-5 bg-darkblue" id="footer">
    <div class="container pt-4">
      <div class="row align-items-top text-center">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-sm-left">
          <h5>{{ $t("footer.aboutTitle") }}</h5>
          <nav class="nav flex-column">
            <router-link to="/about" class="nav-link">{{
              $t("nav.aboutBtn")
            }}</router-link>
            <router-link to="/terms-and-conditions" class="nav-link"
              >{{ $t("footer.t&c") }}</router-link
            >
            <router-link to="/privacy-policy" class="nav-link"
              >{{ $t("footer.pp") }}</router-link
            >
          </nav>
        </div>

        <div
          class="col-12 col-sm-6 col-md-4 col-lg-2 mt-5 mt-sm-0 text-sm-left"
        >
          <h5>{{ $t("footer.learningTitle") }}</h5>
          <nav class="nav flex-column">
             <router-link to="/courses" class="nav-link"
              >{{ $t("nav.coursesBtn") }}</router-link
            >
            <router-link
            to="/private-schools"
            class="nav-link"
          >{{ $t("nav.privateSchoolsBtn") }}
           </router-link>
           
           
            <router-link to="/teachers" class="nav-link"
              >{{ $t("nav.teachersBtn") }}</router-link
            >
           
          </nav>
        </div>

        <div class="col-12 col-md-6 col-lg-3 text-md-left mt-5 mt-md-0">
          <h5>{{ $t("footer.resourcesTitle") }}</h5>
          <nav class="nav flex-column">
            <router-link to="/faq" class="nav-link">{{ $t("nav.faqBtn") }}</router-link>
            <router-link to="/partners" class="nav-link">{{ $t("footer.partners") }}</router-link>
             <router-link to="/code-of-conduct" class="nav-link">{{ $t("footer.codeOfConduct") }}</router-link>
          </nav>
        </div>

        <div class="col-12 col-lg-4 col-sm-6 col-md-4 mt-3 mt-sm-0 text-sm-left">
          <h5>{{ $t("footer.addressText") }}</h5>
          <p class="pt-1">{{ $t("footer.addressBuilding") }} <br/> {{ $t("footer.addressLocation") }} </p>
          <p>
            <a v-for="(data, idx) in socialMediaData" :key="idx"
              :href=data.link
              class="mx-2"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', data.name]" />
            </a>
            <a href="mailto:hello@jskids.ro" class="mx-2"><font-awesome-icon :icon="['fas', 'envelope']" /></a>
            
          </p>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-lg-7 col-md-7 col-sm-12 text-lg-left text-center">
          <small>{{ $t("footer.companyTitle") }} &#8226; {{ $t("footer.companyTitleJSL") }} </small>
        </div>
        <div class="col-12 col-lg-5 col-md-5 col-sm-12 text-lg-right">
          <languageSwitcher />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import socialMediaData from "./../data/socialMedia.json";
import languageSwitcher from "./languageSwitcher.vue";
export default {
  name: "footerJSK",
  data() {
    return {
      socialMediaData: socialMediaData
    };
  },
  components: {
    languageSwitcher
  }
};
</script>
